import { Component, computed, inject } from '@angular/core';
import { NotificationsState, selectLastNVisibleNotifications } from '../+state/notifications/notification.reducer';
import { Store } from '@ngrx/store';
import { NotificationComponent } from './notification.component';

import { selectNotificationUserSettings } from '../../settings/user-settings/+state/settings.selectors';
import { SphereNotificationUserSettingKey } from '../../settings/user-settings/+state/settings.models';

@Component({
    template: `
        <div class="notification-container">
            @if (!dnd()) {
                @for (notification of notifications(); track $index) {
                    <sphere-shell-notification
                        animate.enter="fade-in"
                        [style.margin-bottom.px]="10"
                        [notification]="notification"
                    ></sphere-shell-notification>
                }
            }
        </div>
    `,
    styles: [
        `
            .notification-container {
            }
        `
    ],
    imports: [NotificationComponent]
})
export class NotificationContainerComponent {
    private store = inject(Store<NotificationsState>);

    public notifications = this.store.selectSignal(selectLastNVisibleNotifications(3));
    public notificationSettings = this.store.selectSignal(selectNotificationUserSettings);
    public dnd = computed(() => {
        if (this.notificationSettings()) {
            return this.notificationSettings()[SphereNotificationUserSettingKey.dnd];
        }
        return false;
    });
}
